import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIS } from 'src/app/apis';
import { AbstractAuthorizationService } from '../authorization/authorization.abstract.service';
import { PendingPulseCheckData, PulseCheckRequiredData, UserResponsePresentationData } from './responses-data';
import { ResponsesAbstractService } from './responses.abstract.service';

@Injectable({
  providedIn: 'root'
})
export class ResponsesService implements ResponsesAbstractService {

  public sendUserResponseUrl = `${APIS.responses}/sendUserResponse`;
  public sendTipToSelfUrl = `${APIS.responses}/sendTipToSelf`;
  public sendPulseResponseUrl = `${APIS.responses}/setUserPulseResponse`;
  public sendPulseResponse_noAuthUrl = `${APIS.responses}/setUserPulseResponse_noAuth`;
  public getPulseCheckRequiredDataUrl = `${APIS.responses}/getPulseCheckRequiredData`;
  public getPendingPulseCheckUrl = `${APIS.responses}/getPendingPulseCheck`;

  constructor(
    public http: HttpClient,
    public authorizationService: AbstractAuthorizationService
  ) {}

  sendUserResponse (tokenBody: string, score: number): Observable<UserResponsePresentationData>{
    let result = this.http.post<UserResponsePresentationData>(this.sendUserResponseUrl, { tokenBody: tokenBody, score:score }, {});
    return result;
  }

  getSendUserResponseUrl () : string {
    return this.sendUserResponseUrl;
  }

  getSendToSelfUrl(): string{
    return this.sendTipToSelfUrl;
  }

  sendTipToSelf (tokenBody: string): Observable<string>{
    let result = this.http.post<string>(this.sendTipToSelfUrl, { tokenBody: tokenBody }, {});
    return result;
  }

  sendPulseResponse (totalEnergy:number, driversScore: Record<string, number>, managerialScore: number | null = null) : Observable<string> {
    let result = this.http.post<string>(this.sendPulseResponseUrl, { totalEnergy: totalEnergy, driversScore: driversScore, managerialScore: managerialScore }, {});
    return result;
  }

  sendPulseResponse_noAuth (token: string, totalEnergy:number, driversScore: Record<string, number>, managerialScore: number | null = null) : Observable<string> {
    let result = this.http.post<string>(this.sendPulseResponse_noAuthUrl, { token: token, totalEnergy: totalEnergy, driversScore: driversScore, managerialScore: managerialScore }, {});
    return result;
  }

  getPendingPulseCheck(): Observable<PendingPulseCheckData> {
    return this.http.get<PendingPulseCheckData>(this.getPendingPulseCheckUrl, {});
  }

  getPulseCheckRequiredData(token: string) : Observable<PulseCheckRequiredData>{
    const url = this.getPulseCheckRequiredDataUrl + '?token=' + token;
    let result = this.http.get<PulseCheckRequiredData>(url, {});
    return result;
  }
}
